/**
 * Managed-ads logging (placements API, Home slots, site settings).
 *
 * - Explicit (any build): REACT_APP_DEBUG_ADS=1 or REACT_APP_ADS_TRACE_HOME=1
 * - Development: on for `npm start`; opt out with REACT_APP_SILENCE_ADS_LOG=1
 */
export const SIMIMOVIES_ADS_DEBUG = process.env.REACT_APP_DEBUG_ADS === '1';
export const SIMIMOVIES_ADS_TRACE_HOME = process.env.REACT_APP_ADS_TRACE_HOME === '1';

const isDev = process.env.NODE_ENV === 'development';
const silenceAdsLog = process.env.REACT_APP_SILENCE_ADS_LOG === '1';

/** Use for adService, adActions, sitePublicReducer, and detailed Home traces */
export const logAdsVerbose =
  SIMIMOVIES_ADS_DEBUG || SIMIMOVIES_ADS_TRACE_HOME || (isDev && !silenceAdsLog);

/** Home + ad UI components (StaticAdBanner, PromoAdCard) */
export const logHomeAds = logAdsVerbose;
